import { constants } from "src/shared/constants";
import {
  FAQS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  REGISTRATION_TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const kansascityroyals_pass: TTeamConfig = {
  TEAM_SCHEMA: "kansascityroyals_pass",
  TEAM_FULL_NAME: "Kansas City Royals",
  BROWSER_TITLE: "Kansas City Royals Fountain Pass",
  CLIENT_ID: "M1yBp1jUIJv8hnjbHVPFEBEPGQxxUdoV4ZqytSH83XHlkjnq",
  VENDOR: constants.vendorUUIDs.ticketsdotcom,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#004687",
    COLORS_SECONDARY: "#BD9B60",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,

    ACCOUNT_MANAGER_URL:
      "https://mlb.tickets.com/auth/login/sso?orgId=34007&agency=RYLM_MYTIXX&destination=%2Fticketmanagement%2F%3Forgid%3D34007%26agency%3DRYLM_MYTIXX%26_gl%3D1*1rr7rcy*_gcl_au*MzY5NjA0OTEwLjE3ODUxOTE2MDAuOTY0OTk1MjI4LjE3ODk2MDA3NTAuMTc4OTYwMDc1MC44NzM4NTQ3MjMuMTc4OTYwMDIxNS4xNzg5NjAwNzUw*_ga*MTYxNDE3OTA2Mi4xNzY2OTY4ODAw*_ga_N8YFCZLYSZ*czE3OTA5NzA5OTkkbzE1JGcwJHQxNzkwOTcwOTk5JGo2MCRsMCRoMTg0NjQ5NDg0Nw..*_fplc*WFNYR2Zlb3R5eG1wRURwNHZ0QmQlMkZGejdBaTVaNndReVdzRzF3cTNyTTAyTlJqQ1A5SUtQV2VteWx3RnBXcnc3VmxiRVdJcnc2czdza2p6enpJT2clMkZScmlJZnRRMDlUc3pZMWlGd0xwSlBva3FMdGNwY1pSNTY1bmVVMCUyRnlnJTNEJTNE%23%2F",

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      ADD_SERVICE_FEE_TO_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
      SHOW_FAQ_BUTTON: true,
    },

    HIDE_UPCOMING_EVENTS: true,
    SHOW_ALL_PASSES_UNDER_BANNER: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
    ZERO_STATE: {
      TITLE: "You don't currently have a pass on your account.",
      DESCRIPTION:
        "Purchase a Fountain Pass to start enjoying Kansas City Royals games.",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITION />,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      DISABLE_SAVE_CARD: true,
    },

    HIDE_PASS_SERVICE_FEE: true,
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Royals/kc-royals-logo.svg",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Royals/kansas-city-royals-background.jpg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
